import { BodyRegular, FlexCol, Flex } from 'components/Elements';
import { PublicModuleOverviews } from 'models/PublicCourseOverview';
import styled from 'styled-components';
import { sizes, theme, breakpoints } from 'theme';
import strings from '../../../strings/strings.json';

type ModuleListProps = {
    modules: PublicModuleOverviews[];
};

export default function ModulesList({ modules }: ModuleListProps) {
    return (
        <ModuleContainer>
            {modules
                .sort((a, b) => a.order - b.order)
                .map((module) => (
                    <ModuleCard key={module.order}>
                        <BodyRegular $bold $nowrap>
                            {strings.publicCoursePage.moduleText} {module.order}:
                        </BodyRegular>
                        <BodyRegular>{module.title}</BodyRegular>
                    </ModuleCard>
                ))}
        </ModuleContainer>
    );
}

const ModuleContainer = styled(FlexCol)`
    width: 100%;
    gap: ${sizes.spacingMd};
`;

const ModuleCard = styled(Flex)`
    width: 100%;
    gap: ${sizes.spacingSm};
    white-space: pre-wrap;
    background: ${theme.cardBackground};
    padding: ${sizes.spacingMd};
    border: 2px solid ${theme.primaryButtonBackgroundColour};
    box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: ${sizes.spacingSm};

    @media (max-width: ${breakpoints.md}) {
        flex-direction: column;
    }
`;
